import _classCallCheck from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Vector } from "tsparticles";
var dirsList = [];
var cfg = {
  sides: 6,
  turnSteps: 20,
  angle: 30
};

function createDirs() {
  for (var i = 0; i < 360; i += 360 / cfg.sides) {
    var angle = cfg.angle + i;
    var x = Math.cos(angle * Math.PI / 180);
    var y = Math.sin(angle * Math.PI / 180);
    dirsList.push({
      x: x,
      y: y
    });
  }
}

var PolygonPathGenerator = /*#__PURE__*/function () {
  function PolygonPathGenerator() {
    _classCallCheck(this, PolygonPathGenerator);
  }

  _createClass(PolygonPathGenerator, [{
    key: "generate",
    value: function generate(p) {
      if (p.hexStep === undefined) {
        p.hexStep = 0;
      }

      if (p.hexDirection === undefined) {
        p.hexDirection = cfg.sides === 6 ? (Math.random() * 3 | 0) * 2 : Math.random() * cfg.sides | 0;
      }

      if (p.hexSpeed === undefined) {
        p.hexSpeed = p.velocity.length;
      }

      if (p.hexStep % cfg.turnSteps === 0) {
        p.hexDirection = Math.random() > 0.5 ? (p.hexDirection + 1) % cfg.sides : (p.hexDirection + cfg.sides - 1) % cfg.sides;
      }

      p.velocity.x = 0;
      p.velocity.y = 0;
      p.hexStep++;
      return Vector.create(dirsList[p.hexDirection].x * p.hexSpeed, dirsList[p.hexDirection].y * p.hexSpeed);
    }
  }, {
    key: "init",
    value: function init(container) {
      var options = container.actualOptions.particles.move.path.options;
      cfg.sides = options.sides || 6;
      cfg.angle = options.angle || 30;
      cfg.turnSteps = options.turnSteps || 20;
      createDirs();
    }
  }, {
    key: "update",
    value: function update() {}
  }]);

  return PolygonPathGenerator;
}();

export var polygonPathGenerator = new PolygonPathGenerator();